function relatedItems() {
    $(function() {
        $(window).on("scroll", function() {
            const relatedItems = document.querySelector(".mg-related-items");
            const articleBody = document.querySelector(".entry-content__body");
            const footer = document.querySelector("#colophon");
            const footerDistanceOffScreen =
                footer.getBoundingClientRect().top - window.innerHeight;

            if (!relatedItems || !articleBody) return;

            const checkpoint =
                articleBody.getBoundingClientRect().bottom -
                window.innerHeight +
                175;

            if (checkpoint <= 0 && footerDistanceOffScreen >= 0) {
                $(relatedItems).addClass("mg-related-items--active");
            } else {
                $(relatedItems).removeClass("mg-related-items--active");
            }
        });
    });
}

export default relatedItems;



// WEBPACK FOOTER //
// ./src/js/partials/related-items.js